import type { PermissionString } from "@/types/rbac";

export const PERMISSIONS = {
  USERS: {
    READ: "users.read",
    CREATE: "users.create",
    UPDATE: "users.update",
    DELETE: "users.delete",
  },
  ROLES: {
    READ: "roles.read",
    CREATE: "roles.create",
    UPDATE: "roles.update",
    DELETE: "roles.delete",
  },
  SETTLEMENTS: {
    READ: "settlements.read",
    CREATE: "settlements.create",
    UPDATE: "settlements.update",
    DELETE: "settlements.delete",
  },
  CLIENTS: {
    READ: "clients.read",
    CREATE: "clients.create",
    UPDATE: "clients.update",
    DELETE: "clients.delete",
  },
  REPORTS: {
    READ: "reports.read",
    CREATE: "reports.create",
    DELETE: "reports.delete",
  },
  TOOLKIT: {
    READ: "toolkit.read",
    CREATE: "toolkit.create",
    UPDATE: "toolkit.update",
    DELETE: "toolkit.delete",
  },
  AUDIT: {
    READ: "audit.read",
  },
  CONTESTS: {
    READ: "contests.read",
    CREATE: "contests.create",
    UPDATE: "contests.update",
    DELETE: "contests.delete",
  },
  SETTINGS: {
    READ: "settings.read",
    CREATE: "settings.create",
    UPDATE: "settings.update",
    DELETE: "settings.delete",
  },
} as const satisfies Record<string, Partial<Record<string, PermissionString>>>;

/**
 * Administrators hold every permission; checking the role too means a permission added in a
 * release works for them before their session picks up the new role contents.
 */
export function userHasPermission(
  user: { role: string; permissions: string[] } | null | undefined,
  permission: string,
): boolean {
  return (
    !!user &&
    (user.role === "Administrator" || user.permissions.includes(permission))
  );
}
